import React from "react";

import PageHeader from "../../../../molecules/PatientDetailsV2/PageHeader/PageHeader";

import RedirectComponent from "../../../../atoms/RedirectComponent/RedirectComponent";

const WaterIntakeTaskPage: React.FC<any> = () => {
  return (
    <div>
      <PageHeader title="Water Intake" />
      <RedirectComponent moduleName="water" />
    </div>
  );
};

export default WaterIntakeTaskPage;
